import {isNotStringOrEmptyString} from "@utils/string";
import {isValidEmail} from "@utils/validators";

export const validateEmployerLiabilityData = (data) => {

    let messages = [/*{
        name: 'halt',
        message: 'Halt'
    }*/];

    if(isNotStringOrEmptyString(data.targetProfession)) {
       messages.push({
            name: 'targetProfession',
            message: 'Please specify your target profession'
        });
    }
    
    if(isNotStringOrEmptyString(data.businessPostCode)) {
       messages.push({
            name: 'businessPostCode',
            message: 'Please specify your business post code'
        });
    }
    
    if(isNotStringOrEmptyString(data.title)) {
       messages.push({
            name: 'title',
            message: 'Please specify your title'
        });
    }
    
    if(isNotStringOrEmptyString(data.firstName)) {
       messages.push({
            name: 'firstName',
            message: 'Please specify your first name'
        });
    }
    
    if(isNotStringOrEmptyString(data.lastName)) {
       messages.push({
            name: 'lastName',
            message: 'Please specify your last name'
       })
    }
    
    if(isNotStringOrEmptyString(data.contactEmail)) {
       messages.push({
            name: 'contactEmail',
            message: 'Please specify your email address'
       })
    } else if(!isValidEmail(data.contactEmail)) {
       messages.push({
            name: 'contactEmail',
            message: 'Please specify a valid email address'
       })
    } else if(data.contactEmail.length > 100) {
       messages.push({
            name: 'contactEmail',
            message: 'Email address cannot be longer than 100 characters'
       })
    }
    
    if(isNotStringOrEmptyString(data.contactPhone)) {
       messages.push({
            name: 'contactPhone',
            message: 'Please specify your phone number'
       })
    } else if(data.contactPhone.length > 20) {
       messages.push({
            name: 'contactPhone',
            message: 'Phone number cannot be longer than 20 characters'
       })
    }

    return messages;

}